/**
 * Parse a multiline text into an array of lines.
 *
 * This is useful for parsing texts that use a newline character to separate lines.
 *
 * @param text
 */
export const parse_multiline_text = (text: string): string[] => {
  return text.split("\n").filter(line => line.trim() !== "");
}